module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.24406",
      "conversations-internal-schema": "static-1.11928",
      "head-dlb": "static-1.4360",
      "hs-test-utils": "static-1.7293",
      "hubspot-url-utils": "static-1.3522",
      "HubStyleTokens": "static-2.10799",
      "I18n": "static-7.1443",
      "jasmine-runner": "static-1.5708",
      "quartz": "static-1.6082",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.474",
      "visitor-ui-component-library": "static-1.5459",
      "enviro": "static-4.328",
      "hs-promise-rejection-tracking": "static-1.4750",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "raven-hubspot": "static-1.5536",
      "bend-plugin-trellis-migration": "static-1.2842",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1314",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3841",
      "quartz-core": "static-1.5301",
      "transmute": "static-2.75",
      "HeadJS": "static-2.618",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6768",
      "framer-motion": "static-1.51",
      "hs-test-utils-bend-plugin": "static-1.2404",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.133",
      "foundations-theming": "static-1.3618",
      "i18n-data": "static-1.206",
      "metrics-js": "static-1.9043",
      "moment-timezone": "static-5.66",
      "react-utils": "static-2.4696",
      "jasmine": "static-4.3614",
      "quartz-core-utils": "static-1.2949",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.44",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7746",
      "visitor-ui-component-library-icons": "static-1.5270",
      "rpc-client-utils": "static-1.3995",
      "ts-schema": "static-1.3486",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.120",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.690",
      "hub-http-shared-msw-handlers": "static-1.8197",
      "hubspotter-http": "static-1.3960",
      "hubspotter-http-shared-msw-handlers": "static-1.8195",
      "icons": "static-2.593",
      "mobile-manifest-mixins": "static-1.389",
      "platform-navigation-bootstrap": "static-1.11752",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1-jg-correct-duration-metric.4",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "bend-plugin-foundations-components": "static-1.3037",
      "floating-ui": "static-1.39",
      "foundations-assets": "static-1.4160",
      "foundations-theming-specialty": "static-1.1334",
      "hs-story-utils": "static-1.8648",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.80",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.954",
      "bend-plugin-foundations-theming": "static-1.2101",
      "foundations-theming-base": "static-1.2603",
      "classnames": "static-2.10",
      "cssUtils": "static-1.589",
      "HubStyle": "static-2.11107",
      "sassPrefix": "static-1.139",
      "platform-infra-nav-components": "static-1.7068",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.24406",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11928",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-test-utils": "/hs-test-utils/static-1.7293",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3522",
      "HubStyleTokens": "/HubStyleTokens/static-2.10799",
      "I18n": "/I18n/static-7.1443",
      "jasmine-runner": "/jasmine-runner/static-1.5708",
      "quartz": "/quartz/static-1.6082",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.474",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5459",
      "enviro": "/enviro/static-4.328",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2842",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1314",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3841",
      "quartz-core": "/quartz-core/static-1.5301",
      "transmute": "/transmute/static-2.75",
      "HeadJS": "/HeadJS/static-2.618",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6768",
      "framer-motion": "/framer-motion/static-1.51",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2404",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.133",
      "foundations-theming": "/foundations-theming/static-1.3618",
      "i18n-data": "/i18n-data/static-1.206",
      "metrics-js": "/metrics-js/static-1.9043",
      "moment-timezone": "/moment-timezone/static-5.66",
      "react-utils": "/react-utils/static-2.4696",
      "jasmine": "/jasmine/static-4.3614",
      "quartz-core-utils": "/quartz-core-utils/static-1.2949",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.44",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7746",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5270",
      "rpc-client-utils": "/rpc-client-utils/static-1.3995",
      "ts-schema": "/ts-schema/static-1.3486",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.120",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.690",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8197",
      "hubspotter-http": "/hubspotter-http/static-1.3960",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8195",
      "icons": "/icons/static-2.593",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.389",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11752",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1-jg-correct-duration-metric.4",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3037",
      "floating-ui": "/floating-ui/static-1.39",
      "foundations-assets": "/foundations-assets/static-1.4160",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1334",
      "hs-story-utils": "/hs-story-utils/static-1.8648",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.80",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.954",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2101",
      "foundations-theming-base": "/foundations-theming-base/static-1.2603",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.589",
      "HubStyle": "/HubStyle/static-2.11107",
      "sassPrefix": "/sassPrefix/static-1.139",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7068",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};